import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { formatRut } from '@fdograph/rut-utilities';
import React, { useEffect, useState } from 'react';
import BadgeUserType from '../../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../../resources/types';
import { buildBreadcrumbItems, getBankSvg, getCookie, getUrlVersion, getUser, setLoading } from '../../../../../commons/functions';
const _preserve = React.version;

export const AdminMovementsPACUsersPage = () => {
    const { data, menu, parameters } = useGlobalState();
    useGlobalState();
    const [users, setUsers] = useState<ItemUser[]>([]);


    const handleRefresh = async () => {
        ///private/user/movements/pac/initsubscription
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ columns: "idUser, displayName, jsonFintoc, idUserType", orderBy: "displayName", order: "asc", isPAC: 1 }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                setUsers(dataWeb.users)
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }
    useEffect(() => {
        handleRefresh();
    }, [parameters.period]);

    const error = (item: any) => {
        if (item) {
            if (item === "login_invalid_credentials")
                return "Credenciales inválidas";
            else if (item === "login_credentials_locked")
                return "Credenciales bloquedas";
            else if (item === "authorization_failed")
                return "Autorización fallida";
            else if (item === "authorization_timeout")
                return "Autorización expirada";
            else if (item === "request_timeout")
                return "Tiempo de espera agotado";
            else if (item === "subscription_intent_expired")
                return "Intento de suscripción expirado";
            else if (item === "internal_error")
                return "Error interno";
            else if (item === "insufficient_funds")
                return "Fondos insuficientes";
            else if (item === "subscription_inactive")
                return "Convenio inactivo";
            else if (item === "charge_amount_limit_exceeded")
                return "Límite de monto excedido";
            else if (item === "other")
                return "Error desconocido";

        } else {
            return ""
        }

    }

    const status = (item: any) => {
        if (item.type === "subscription_intent") {
            if (item.status === "created") {
                return <FormField label={"Ingresada"}></FormField>;
            } else if (item.status === "progress") {
                return <FormField label={"Esperando autorización"}></FormField>;
            } else if (item.status === "succeeded") {
                return <FormField label={"Finalizado"}></FormField>;
            } else if (item.status === "rejected") {
                return <FormField label={"Rechazado"}></FormField>;
            } else if (item.status === "failed") {
                return <FormField label={"Error"}>{error(item.json.public_error)}</FormField>;
            } else {
                return item.status;
            }
        }
        else if (item.type === "subscription") {
            if (item.status === "pending") {
                return <FormField label={"Pendiente"}></FormField>;
            }
            else if (item.status === "active") {
                return <FormField label={"Activo"}></FormField>;
            }
            else if (item.status === "canceled") {
                return <FormField label={"Cancelado"}></FormField>;
            }
        }
        else if (item.type === "charge") {
            if (item.status === "pending") {
                return <FormField label={"Pendiente"}></FormField>;
            }
            else if (item.status === "succeeded") {
                return <FormField label={"Completado"}></FormField>;
            }
            else if (item.status === "in_progress") {
                return <FormField label={"Gestionando"}></FormField>;
            }
            else if (item.status === "failed") {
                return <FormField label={"Rechazada"}>{error(item.json.failure_code)}</FormField>;
            }
        }
    }

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}
                        description={"Listado de usuarios convenios PAC activos"}
                    >Usuarios PAC</Header>
                    {!!users && (


                        <Table
                            variant='embedded'
                            cellVerticalAlign='top'
                            columnDefinitions={[
                                {
                                    id: "user",
                                    header: "Usuario",
                                    cell: item => <FormField label={getUser(item.idUser, data).displayName}><BadgeUserType size='small' type='normal' idUserType={getUser(item.idUser, data).idUserType} /></FormField>


                                },
                                {
                                    id: "subscription",
                                    header: "Mandato",
                                    cell: item => <FormField
                                        constraintText={item.jsonFintoc.id}

                                        label={`RUT ${formatRut(item.jsonFintoc.payment_method.pac.account_holder_id ?? "")}`}>{item.jsonFintoc.payment_method.pac.holder_name ?? ""}</FormField>


                                },
                                {
                                    id: "account",
                                    header: "Cuenta",
                                    cell: item => <FormField
                                        constraintText={item.jsonFintoc.payment_method.pac.institution.name ?? ""}
                                        label={item.jsonFintoc.payment_method.pac.account_number}>{item.jsonFintoc.payment_method.pac.name}</FormField>
                                },
                                {
                                    id: "bank",
                                    header: "Banco",
                                    cell: item => (
                                        <div
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "35", height: "35" }}
                                            dangerouslySetInnerHTML={{ __html: getBankSvg(item.jsonFintoc.payment_method.pac.institution.id) }}
                                        />
                                    )
                                },
                            ]}
                            items={users || []}
                        />
                        /*subscriptions.filter((s: any) => s.subscription.id)*/
                    )}
                </SpaceBetween>
            }
        />
    )
};
